import { Box, Chip, } from "@mui/material";
import { FC } from "react";


const FaultGroups: FC<any> = ({ faultGroupArray }) => {

    let faultGroupLines = [];
    let faultLineEntityCount = 0;
    let faultGroupLine: string[] = [];
    for (let i = 0; i < faultGroupArray?.length; i++) {
        faultLineEntityCount++;
        if (faultLineEntityCount > 4) {
            faultGroupLines.push(faultGroupLine);
            faultLineEntityCount = 1;
            faultGroupLine = [];
        }
        faultGroupLine.push(faultGroupArray?.[i]);
    }
    if (faultGroupLine?.length) {
        faultGroupLines.push(faultGroupLine);
    }

    return (
        <>
            {faultGroupLines.map((faultGroupLine: any, index: number) => {
                return (<Box display={'flex'}>
                    {faultGroupLine.map((fault: any, faultIndex: number) => {
                        return (
                            <Chip variant="filled"
                                size='small'
                                sx={{ borderColor: 'neutral.300', color: 'text.primary', mr: 1, mb: faultGroupLines?.length - 1 === index ? 0 : 0.5 }}
                                label={fault} />

                        )
                    })}
                </Box>)
            })}
        </>
    );
};

export default FaultGroups;